<app-complex-modal-template
    class="overflow-visible"
    [canConfirm]="positionForm.valid"
    [title]="'synopticPlan.editPosition' | transloco"
    (onClickEvent)="submit($event)">
    <form [formGroup]="positionForm">
        <app-select
            [inputFormControl]="positionForm.controls.function"
            [isMultiSelect]="false"
            [label]="'synopticPlan.function' | transloco"
            [options]="functionTypes"
            (optionSelected)="positionForm.controls.function.setValue($event[0])" />

        <app-select
            [inputFormControl]="positionForm.controls.engineeringType"
            [isMultiSelect]="false"
            [label]="'synopticPlan.engineeringType' | transloco"
            [options]="engineeringTypes"
            (optionSelected)="positionForm.controls.engineeringType.setValue($event[0])" />

        <app-select
            [inputFormControl]="positionForm.controls.assignment"
            [isMultiSelect]="false"
            [label]="'assignment' | transloco"
            [options]="assignmentOptions"
            (optionSelected)="positionForm.controls.assignment.setValue($event[0])" />
    </form>
</app-complex-modal-template>
